module.exports = __webpack_public_path__ + "img/xp2_skybar.d752e3be.jpg";